import { StepName } from './stepNames';
import { FieldToStepMap } from './step';

export const mapFieldToStep: FieldToStepMap = new Map([
  ['phone', StepName.Initial],
  ['mainCareerId', StepName.MainCareer],
  ['clientType', StepName.ClientType],

  ['cityId', StepName.Location],
  ['location', StepName.Location],
  ['deviceLocation', StepName.Location],

  ['address', StepName.Location],

  ['name', StepName.Acquaintance],
  ['surname', StepName.Acquaintance],
  ['patronymic', StepName.Acquaintance],
  ['sex', StepName.Acquaintance],
  ['birthDate', StepName.Acquaintance],
  ['email', StepName.Acquaintance],

  ['tariffId', StepName.Tariff],
]);
